// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"1e76a7a5cfd3e415","9670":"567d5be95c9ad14a"}[chunkId] + ".css";
};